import { cn } from "@/lib/utils";

type Props = {
  suggestions: string[];
  disabled?: boolean;
  onSelect: (text: string) => void;
  className?: string;
};

export function AssistantComposerSuggestions({
  suggestions,
  disabled = false,
  onSelect,
  className,
}: Props) {
  if (suggestions.length === 0) return null;

  return (
    <div className={cn("mb-2", className)}>
      <p className="mb-1.5 text-[11px] font-medium uppercase tracking-wide text-[var(--lm-muted)] dark:text-slate-400">
        Suggestions
      </p>
      <div className="-mx-0.5 flex max-h-24 flex-wrap gap-1.5 overflow-y-auto overscroll-none px-0.5 pb-0.5">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(suggestion)}
            className={cn(
              "shrink-0 rounded-full border border-[rgba(15,23,42,0.12)] bg-white px-2.5 py-1 text-left text-xs text-[#576274]",
              "transition-colors hover:border-blue-500/40 hover:bg-[var(--lm-hover)] hover:text-[#101828]",
              "disabled:cursor-not-allowed disabled:opacity-50",
              "dark:border-white/10 dark:bg-white/5 dark:text-gray-300 dark:hover:bg-white/10 dark:hover:text-white"
            )}
          >
            <span className="text-[#1d4ed8] dark:text-blue-400">+ </span>
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
}
